import soilHistory from './soil-history';

export default soilHistory;